import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('_DB_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => openWindow('/LlmBdLogicForeignKeyList', {prjId, sVer})

    return {
        label: '待处理外键关系清单',
        onClick,
        ...props
    }
}
